const pageFaqMap = {
  about: {
    title: /** @i18n */ "faq.about.title",
    description: /** @i18n */ "faq.about.description",
    items: [
      {
        question: /** @i18n */ "faq.about.q1.question",
        answer: /** @i18n */ "faq.about.q1.answer",
      },
      {
        question: /** @i18n */ "faq.about.q2.question",
        answer: /** @i18n */ "faq.about.q2.answer",
      },
      {
        question: /** @i18n */ "faq.about.q3.question",
        answer: /** @i18n */ "faq.about.q3.answer",
      },
    ],
  },
  announcements: {
    title: /** @i18n */ "faq.announcements.title",
    description: /** @i18n */ "faq.announcements.description",
    items: [
      {
        question: /** @i18n */ "faq.announcements.q1.question",
        answer: /** @i18n */ "faq.announcements.q1.answer",
      },
      {
        question: /** @i18n */ "faq.announcements.q2.question",
        answer: /** @i18n */ "faq.announcements.q2.answer",
      },
      {
        question: /** @i18n */ "faq.announcements.q3.question",
        answer: /** @i18n */ "faq.announcements.q3.answer",
      },
      {
        question: /** @i18n */ "faq.announcements.q4.question",
        answer: /** @i18n */ "faq.announcements.q4.answer",
      },
    ],
  },
  becomePartner: {
    title: /** @i18n */ "faq.becomePartnerReferral.title",
    description: /** @i18n */ "faq.becomePartnerReferral.description",
    items: [
      {
        question: /** @i18n */ "faq.becomePartnerReferral.q1.question",
        answer: /** @i18n */ "faq.becomePartnerReferral.q1.answer",
      },
      {
        question: /** @i18n */ "faq.becomePartnerReferral.q2.question",
        answer: /** @i18n */ "faq.becomePartnerReferral.q2.answer",
      },
      {
        question: /** @i18n */ "faq.becomePartnerReferral.q3.question",
        answer: /** @i18n */ "faq.becomePartnerReferral.q3.answer",
      },
      {
        question: /** @i18n */ "faq.becomePartnerReferral.q4.question",
        answer: /** @i18n */ "faq.becomePartnerReferral.q4.answer",
      },
    ],
  },
  becomeTechPartner: {
    title: /** @i18n */ "faq.becomeTechPartner.title",
    description: /** @i18n */ "faq.becomeTechPartner.description",
    items: [
      {
        question: /** @i18n */ "faq.becomeTechPartner.q1.question",
        answer: /** @i18n */ "faq.becomeTechPartner.q1.answer",
      },
      {
        question: /** @i18n */ "faq.becomeTechPartner.q2.question",
        answer: /** @i18n */ "faq.becomeTechPartner.q2.answer",
      },
      {
        question: /** @i18n */ "faq.becomeTechPartner.q3.question",
        answer: /** @i18n */ "faq.becomeTechPartner.q3.answer",
      },
      {
        question: /** @i18n */ "faq.becomeTechPartner.q4.question",
        answer: /** @i18n */ "faq.becomeTechPartner.q4.answer",
      },
    ],
  },
  blog: {
    title: /** @i18n */ "faq.blog.title",
    description: /** @i18n */ "faq.blog.description",
    items: [
      {
        question: /** @i18n */ "faq.blog.q1.question",
        answer: /** @i18n */ "faq.blog.q1.answer",
      },
      {
        question: /** @i18n */ "faq.blog.q2.question",
        answer: /** @i18n */ "faq.blog.q2.answer",
      },
      {
        question: /** @i18n */ "faq.blog.q3.question",
        answer: /** @i18n */ "faq.blog.q3.answer",
      },
      {
        question: /** @i18n */ "faq.blog.q4.question",
        answer: /** @i18n */ "faq.blog.q4.answer",
      },
    ],
  },
  career: {
    title: /** @i18n */ "faq.career.title",
    description: /** @i18n */ "faq.career.description",
    items: [
      {
        question: /** @i18n */ "faq.career.q1.question",
        answer: /** @i18n */ "faq.career.q1.answer",
      },
      {
        question: /** @i18n */ "faq.career.q2.question",
        answer: /** @i18n */ "faq.career.q2.answer",
      },
      {
        question: /** @i18n */ "faq.career.q3.question",
        answer: /** @i18n */ "faq.career.q3.answer",
      },
      {
        question: /** @i18n */ "faq.career.q4.question",
        answer: /** @i18n */ "faq.career.q4.answer",
      },
    ],
  },
  chatbot: {
    title: /** @i18n */ "faq.chatbot.title",
    description: /** @i18n */ "faq.chatbot.description",
    items: [
      {
        question: /** @i18n */ "faq.chatbot.q5.question",
        answer: /** @i18n */ "faq.chatbot.q5.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q6.question",
        answer: /** @i18n */ "faq.chatbot.q6.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q7.question",
        answer: /** @i18n */ "faq.chatbot.q7.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q8.question",
        answer: /** @i18n */ "faq.chatbot.q8.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q9.question",
        answer: /** @i18n */ "faq.chatbot.q9.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q10.question",
        answer: /** @i18n */ "faq.chatbot.q10.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q11.question",
        answer: /** @i18n */ "faq.chatbot.q11.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q14.question",
        answer: /** @i18n */ "faq.chatbot.q14.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q20.question",
        answer: /** @i18n */ "faq.chatbot.q20.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q21.question",
        answer: /** @i18n */ "faq.chatbot.q21.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q23.question",
        answer: /** @i18n */ "faq.chatbot.q23.answer",
      },
      {
        question: /** @i18n */ "faq.chatbot.q24.question",
        answer: /** @i18n */ "faq.chatbot.q24.answer",
      },
    ],
  },
  ebooks: {
    title: /** @i18n */ "faq.ebooks.title",
    description: /** @i18n */ "faq.ebooks.description",
    items: [
      {
        question: /** @i18n */ "faq.ebooks.q1.question",
        answer: /** @i18n */ "faq.ebooks.q1.answer",
      },
      {
        question: /** @i18n */ "faq.ebooks.q2.question",
        answer: /** @i18n */ "faq.ebooks.q2.answer",
      },
      {
        question: /** @i18n */ "faq.ebooks.q3.question",
        answer: /** @i18n */ "faq.ebooks.q3.answer",
      },
      {
        question: /** @i18n */ "faq.ebooks.q4.question",
        answer: /** @i18n */ "faq.ebooks.q4.answer",
      },
    ],
  },
  googleMaps: {
    title: /** @i18n */ "faq.googleMaps.title",
    description: /** @i18n */ "faq.googleMaps.description",
    items: [
      {
        question: /** @i18n */ "faq.googleMaps.q1.question",
        answer: /** @i18n */ "faq.googleMaps.q1.answer",
      },
      {
        question: /** @i18n */ "faq.googleMaps.q2.question",
        answer: /** @i18n */ "faq.googleMaps.q2.answer",
      },
      {
        question: /** @i18n */ "faq.googleMaps.q3.question",
        answer: /** @i18n */ "faq.googleMaps.q3.answer",
      },
      {
        question: /** @i18n */ "faq.googleMaps.q4.question",
        answer: /** @i18n */ "faq.googleMaps.q4.answer",
      },
    ],
  },
  home: {
    title: /** @i18n */ "faq.home.title",
    description: /** @i18n */ "faq.home.description",
    items: [
      {
        question: /** @i18n */ "faq.home.q1.question",
        answer: /** @i18n */ "faq.home.q1.answer",
      },
      {
        question: /** @i18n */ "faq.home.q2.question",
        answer: /** @i18n */ "faq.home.q2.answer",
      },
      {
        question: /** @i18n */ "faq.home.q3.question",
        answer: /** @i18n */ "faq.home.q3.answer",
      },
      {
        question: /** @i18n */ "faq.home.q4.question",
        answer: /** @i18n */ "faq.home.q4.answer",
      },
      {
        question: /** @i18n */ "faq.home.q5.question",
        answer: /** @i18n */ "faq.home.q5.answer",
      },
      {
        question: /** @i18n */ "faq.home.q6.question",
        answer: /** @i18n */ "faq.home.q6.answer",
      },
      {
        question: /** @i18n */ "faq.home.q7.question",
        answer: /** @i18n */ "faq.home.q7.answer",
      },
      {
        question: /** @i18n */ "faq.home.q8.question",
        answer: /** @i18n */ "faq.home.q8.answer",
      },
      {
        question: /** @i18n */ "faq.home.q9.question",
        answer: /** @i18n */ "faq.home.q9.answer",
      },
      {
        question: /** @i18n */ "faq.home.q10.question",
        answer: /** @i18n */ "faq.home.q10.answer",
      },
      {
        question: /** @i18n */ "faq.home.q11.question",
        answer: /** @i18n */ "faq.home.q11.answer",
      },
      {
        question: /** @i18n */ "faq.home.q12.question",
        answer: /** @i18n */ "faq.home.q12.answer",
      },
      {
        question: /** @i18n */ "faq.home.q13.question",
        answer: /** @i18n */ "faq.home.q13.answer",
      },
    ],
  },
  integrations: {
    title: /** @i18n */ "faq.integrations.title",
    description: /** @i18n */ "faq.integrations.description",
    items: [
      {
        question: /** @i18n */ "faq.integrations.q1.question",
        answer: /** @i18n */ "faq.integrations.q1.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q2.question",
        answer: /** @i18n */ "faq.integrations.q2.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q3.question",
        answer: /** @i18n */ "faq.integrations.q3.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q4.question",
        answer: /** @i18n */ "faq.integrations.q4.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q5.question",
        answer: /** @i18n */ "faq.integrations.q5.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q6.question",
        answer: /** @i18n */ "faq.integrations.q6.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q7.question",
        answer: /** @i18n */ "faq.integrations.q7.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q8.question",
        answer: /** @i18n */ "faq.integrations.q8.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q9.question",
        answer: /** @i18n */ "faq.integrations.q9.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q10.question",
        answer: /** @i18n */ "faq.integrations.q10.answer",
      },
      {
        question: /** @i18n */ "faq.integrations.q11.question",
        answer: /** @i18n */ "faq.integrations.q11.answer",
      },
    ],
  },
  integrationsWhatsapp: {
    title: /** @i18n */ "faq.integrationsWhatsapp.title",
    description: /** @i18n */ "faq.integrationsWhatsapp.description",
    items: [
      {
        question: /** @i18n */ "faq.integrationsWhatsapp.q1.question",
        answer: /** @i18n */ "faq.integrationsWhatsapp.q1.answer",
      },
      {
        question: /** @i18n */ "faq.integrationsWhatsapp.q2.question",
        answer: /** @i18n */ "faq.integrationsWhatsapp.q2.answer",
      },
      {
        question: /** @i18n */ "faq.integrationsWhatsapp.q3.question",
        answer: /** @i18n */ "faq.integrationsWhatsapp.q3.answer",
      },
      {
        question: /** @i18n */ "faq.integrationsWhatsapp.q4.question",
        answer: /** @i18n */ "faq.integrationsWhatsapp.q4.answer",
      },
      {
        question: /** @i18n */ "faq.integrationsWhatsapp.q5.question",
        answer: /** @i18n */ "faq.integrationsWhatsapp.q5.answer",
      },
      {
        question: /** @i18n */ "faq.integrationsWhatsapp.q6.question",
        answer: /** @i18n */ "faq.integrationsWhatsapp.q6.answer",
      },
    ],
  },
  keepInTouch: {
    title: /** @i18n */ "faq.keepInTouch.title",
    description: /** @i18n */ "faq.keepInTouch.description",
    items: [
      {
        question: /** @i18n */ "faq.keepInTouch.q1.question",
        answer: /** @i18n */ "faq.keepInTouch.q1.answer",
      },
      {
        question: /** @i18n */ "faq.keepInTouch.q2.question",
        answer: /** @i18n */ "faq.keepInTouch.q2.answer",
      },
      {
        question: /** @i18n */ "faq.keepInTouch.q3.question",
        answer: /** @i18n */ "faq.keepInTouch.q3.answer",
      },
      {
        question: /** @i18n */ "faq.keepInTouch.q4.question",
        answer: /** @i18n */ "faq.keepInTouch.q4.answer",
      },
    ],
  },
  pricing: {
    title: /** @i18n */ "faq.pricing.title",
    description: /** @i18n */ "faq.pricing.description",
    items: [
      {
        question: /** @i18n */ "faq.pricing.q1.question",
        answer: /** @i18n */ "faq.pricing.q1.answer",
      },
      {
        question: /** @i18n */ "faq.pricing.q2.question",
        answer: /** @i18n */ "faq.pricing.q2.answer",
      },
      {
        question: /** @i18n */ "faq.pricing.q3.question",
        answer: /** @i18n */ "faq.pricing.q3.answer",
      },
      {
        question: /** @i18n */ "faq.pricing.q4.question",
        answer: /** @i18n */ "faq.pricing.q4.answer",
      },
      {
        question: /** @i18n */ "faq.pricing.q5.question",
        answer: /** @i18n */ "faq.pricing.q5.answer",
      },
      {
        question: /** @i18n */ "faq.pricing.q6.question",
        answer: /** @i18n */ "faq.pricing.q6.answer",
      },
      {
        question: /** @i18n */ "faq.pricing.q7.question",
        answer: /** @i18n */ "faq.pricing.q7.answer",
      },
      {
        question: /** @i18n */ "faq.pricing.q8.question",
        answer: /** @i18n */ "faq.pricing.q8.answer",
      },
    ],
  },
  successStories: {
    title: /** @i18n */ "faq.successStories.title",
    description: /** @i18n */ "faq.successStories.description",
    items: [
      {
        question: /** @i18n */ "faq.successStories.q1.question",
        answer: /** @i18n */ "faq.successStories.q1.answer",
      },
      {
        question: /** @i18n */ "faq.successStories.q2.question",
        answer: /** @i18n */ "faq.successStories.q2.answer",
      },
      {
        question: /** @i18n */ "faq.successStories.q3.question",
        answer: /** @i18n */ "faq.successStories.q3.answer",
      },
      {
        question: /** @i18n */ "faq.successStories.q4.question",
        answer: /** @i18n */ "faq.successStories.q4.answer",
      },
    ],
  },
  liveChatTicket: {
    title: /** @i18n */ "faq.liveChatTicket.title",
    description: /** @i18n */ "faq.liveChatTicket.description",
    items: [
      {
        question: /** @i18n */ "faq.liveChatTicket.q1.question",
        answer: /** @i18n */ "faq.liveChatTicket.q1.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q2.question",
        answer: /** @i18n */ "faq.liveChatTicket.q2.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q3.question",
        answer: /** @i18n */ "faq.liveChatTicket.q3.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q4.question",
        answer: /** @i18n */ "faq.liveChatTicket.q4.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q5.question",
        answer: /** @i18n */ "faq.liveChatTicket.q5.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q6.question",
        answer: /** @i18n */ "faq.liveChatTicket.q6.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q7.question",
        answer: /** @i18n */ "faq.liveChatTicket.q7.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q8.question",
        answer: /** @i18n */ "faq.liveChatTicket.q8.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q9.question",
        answer: /** @i18n */ "faq.liveChatTicket.q9.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q10.question",
        answer: /** @i18n */ "faq.liveChatTicket.q10.answer",
      },
      {
        question: /** @i18n */ "faq.liveChatTicket.q11.question",
        answer: /** @i18n */ "faq.liveChatTicket.q11.answer",
      },
    ],
  },
  "solutions.customerSupport": {
    title: /** @i18n */ "faq.solutions.customerSupport.title",
    description: /** @i18n */ "faq.solutions.customerSupport.description",
    items: [
      {
        question: /** @i18n */ "faq.solutions.customerSupport.q1.question",
        answer: /** @i18n */ "faq.solutions.customerSupport.q1.answer",
      },
      {
        question: /** @i18n */ "faq.solutions.customerSupport.q2.question",
        answer: /** @i18n */ "faq.solutions.customerSupport.q2.answer",
      },
      {
        question: /** @i18n */ "faq.solutions.customerSupport.q3.question",
        answer: /** @i18n */ "faq.solutions.customerSupport.q3.answer",
      },
    ],
  },
  "solutions.ecommerce": {
    title: /** @i18n */ "faq.solutions.ecommerce.title",
    description: /** @i18n */ "faq.solutions.ecommerce.description",
    items: [
      {
        question: /** @i18n */ "faq.solutions.ecommerce.q1.question",
        answer: /** @i18n */ "faq.solutions.ecommerce.q1.answer",
      },
      {
        question: /** @i18n */ "faq.solutions.ecommerce.q2.question",
        answer: /** @i18n */ "faq.solutions.ecommerce.q2.answer",
      },
      {
        question: /** @i18n */ "faq.solutions.ecommerce.q3.question",
        answer: /** @i18n */ "faq.solutions.ecommerce.q3.answer",
      },
      {
        question: /** @i18n */ "faq.solutions.ecommerce.q4.question",
        answer: /** @i18n */ "faq.solutions.ecommerce.q4.answer",
      },
    ],
  },
  "solutions.sales": {
    title: /** @i18n */ "faq.solutions.sales.title",
    description: /** @i18n */ "faq.solutions.sales.description",
    items: [
      {
        question: /** @i18n */ "faq.solutions.sales.q1.question",
        answer: /** @i18n */ "faq.solutions.sales.q1.answer",
      },
      {
        question: /** @i18n */ "faq.solutions.sales.q2.question",
        answer: /** @i18n */ "faq.solutions.sales.q2.answer",
      },
    ],
  },
  "solutions.marketing": {
    title: /** @i18n */ "faq.solutions.marketing.title",
    description: /** @i18n */ "faq.solutions.marketing.description",
    items: [
      {
        question: /** @i18n */ "faq.solutions.marketing.q1.question",
        answer: /** @i18n */ "faq.solutions.marketing.q1.answer",
      },
      {
        question: /** @i18n */ "faq.solutions.marketing.q2.question",
        answer: /** @i18n */ "faq.solutions.marketing.q2.answer",
      },
    ],
  },
  "solutions.hospitality": {
    title: /** @i18n */ "faq.solutions.hospitality.title",
    description: /** @i18n */ "faq.solutions.hospitality.description",
    items: [
      {
        question: /** @i18n */ "faq.solutions.hospitality.q1.question",
        answer: /** @i18n */ "faq.solutions.hospitality.q1.answer",
      },
    ],
  },
  "solutions.government": {
    title: /** @i18n */ "faq.solutions.government.title",
    description: /** @i18n */ "faq.solutions.government.description",
    items: [
      {
        question: /** @i18n */ "faq.solutions.government.q1.question",
        answer: /** @i18n */ "faq.solutions.government.q1.answer",
      },
      {
        question: /** @i18n */ "faq.solutions.government.q2.question",
        answer: /** @i18n */ "faq.solutions.government.q2.answer",
      },
      {
        question: /** @i18n */ "faq.solutions.government.q3.question",
        answer: /** @i18n */ "faq.solutions.government.q3.answer",
      },
    ],
  },
};

export const getPageFaqContent = (t, pageKey) => {
  const entry = pageFaqMap[pageKey];
  if (!entry || typeof t !== "function") return null;

  return {
    title: t(entry.title),
    description: t(entry.description),
    faqData: entry.items.map((item) => ({
      question: t(item.question),
      answer: t(item.answer),
    })),
  };
};
